import usePrivateAxios from "@/common/api/usePrivateAxios";
import { useMutation } from "@tanstack/react-query";

interface UseUpdateEstablishmentLeadContractFee {
  establishmentLeadId?: string,
  onSuccess?: (response: any) => void,
  onError?: (error: any) => void
}

export const useUpdateEstablishmentLeadContractFee = ({ establishmentLeadId, onSuccess, onError }: UseUpdateEstablishmentLeadContractFee) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['updateEstablishmentLeadContractFee'],
    mutationFn: async (data: { id: string, value?: string, main_fee?: boolean }) => {
      const lead = {
        contract_attributes: {
          contract_fees_attributes: data
        }
      }

      await privateAxios.put(`/funnel/establishment/leads/${establishmentLeadId}`, {
        lead
      })
    },
    onSuccess,
    onError,
  })
}
